import {cloneDeep} from "lodash";
import {getString, resetObjectValues} from "Core/helpers/data";
import {CustomerGroupsItemDataObject} from "../dataObjects";

/**
 * Get input data from raw data
 * @param {Object} rawData - Raw data received from IO.
 * @return {CustomerGroupsItemDataObject}
 */
export const input = rawData => {
	let result = cloneDeep(rawData);

	result = new CustomerGroupsItemDataObject(
		getString(result, 'id'),
		getString(result, 'name'),
		getString(result, 'description'),
		getString(result, 'projectId'),
		getString(result, 'status'),
	);

	return result;
}

/**
 * Get output data from input data
 * @param {CustomerGroupsItemDataObject} inputData - Input data.
 * @return {Object}
 */
export const output = inputData => {
	let result = cloneDeep({
		id: inputData.id,
		name: inputData.name,
		description: inputData.description,
		projectId: inputData.projectId,
		status: inputData.status,
	});

	// Set proper empty values expected by the API
	result = resetObjectValues(result);

	return result;
}